import React, { FC, ReactNode } from "react";
import { CardContent } from "@mui/material";


import { CardStyled } from "./CardGuide.styled";
import CardGuideStep from "./components/CardGuideStep";
import CardGuideStepDetail from "./components/CardGuideStepDetail";
import CardGuideHeader from "./components/CardGuideHeader";
import CardGuideLine from "./components/CardGuideLine";

import { Box, Grid } from "@components/base";


interface CardGuide {
  title: string;
  titleTooltip: string;
  steps: CardGuideStep[];
  clicked?: boolean[];
  onClickStep: (stepIndex: number) => void;
  active?: number;
  children?: ReactNode;
  rightTitleContent?: ReactNode;
  disabled?: boolean;
}

const CardGuide: FC<CardGuide> = ({
  title,
  titleTooltip,
  steps,
  onClickStep,
  active,
  clicked,
  children,
  rightTitleContent,
  disabled,
}) => (
  <CardStyled>
    <CardGuideHeader title={title} titleTooltip={titleTooltip}>
      {rightTitleContent}
    </CardGuideHeader>
    <CardContent className="card-content">
      <Box className="steps-container">
        <Box className="steps">
          <Box mb={1.75}>
            <Grid container>
              {steps.map((_, index) => (
                <Grid flex={1 / steps.length} key={`guide-step-progress-${index}`}>
                  <CardGuideLine
                    index={index}
                    active={index === active}
                    isLast={index < steps.length - 1}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
          <Grid container spacing={1.75} alignContent="stretch">
            {steps.map((step, index) => (
              <Grid flex={1 / steps.length} key={`guide-step-${index}`}>
                <CardGuideStep
                  {...step}
                  clicked={clicked?.[index]}
                  active={index === active}
                  onClickStep={() => (!disabled ? onClickStep(index) : undefined)}
                  disabled={disabled}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
      {active !== undefined && steps[active]?.detail && (
        <Box mt={3} className="detail">
          <CardGuideStepDetail
            detail={steps[active].detail}
            button={steps[active].button}
          />
        </Box>
      )}
      {children}
    </CardContent>
  </CardStyled>
);

export default CardGuide;
